import { render, staticRenderFns } from "./BlueprintsTab.vue?vue&type=template&id=052ae810&"
import script from "./BlueprintsTab.vue?vue&type=script&lang=ts&"
export * from "./BlueprintsTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports